import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router';
import { Button } from 'react-bootstrap';
import _ from 'lodash';

import * as BECaller from '../../../util/apiCaller';
import FormattedMessage from '../../../components/FormattedMessage';
import Testimonial from '../components/Testimonial/Testimonial.js';
import { notifyForToken } from '../../../util/iframeNotifier';
import { extractHostname } from '../../../util/url';
import storageHelper from '../../../util/storageHelper';
import { handleError } from '../AuthActions';
import { intl } from '../../Intl/IntlGlobalWrapper';
import LoginForm from '../components/LoginForm';
import Loading from '../../../components/Loading/Loading';
import { trackLoginPageView, trackHowToOpened } from '../../../util/mixpanel';

import trello from './img/trello-icon.svg';
import asana from './img/asana-icon.svg';
import jira from './img/jira-icon.svg';
import jiraCloud from './img/jira-icon-cloud.svg';

import logo from './img/logo-nave-icon.svg';

// Import Style
import '../Auth.scss';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      host: '',
      hostFlag: false
    };
  }

  received = false;

  componentDidMount() {
    if (this.props.routeParams.accountId) {
      global.window &&
        window.location &&
        window.location.replace(`/auth/sso/login/${this.props.routeParams.accountId}` + window.location.search);
      return;
    }
    if (this.props.location.search.includes('cloud')) {
      storageHelper.storage().removeItem('hostFlag');
    }
    else if (this.props.location.search.includes('server')) {
      storageHelper.storage().setItem('hostFlag', true);
    }
    const host = storageHelper.storage().getItem('host');
    const hostFlag = storageHelper.storage().getItem('hostFlag');
    if (hostFlag) {
      this.setState({
        host,
        hostFlag
      });
    }

    trackLoginPageView(window.location.hostname.split('.')[0]);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.plugin != this.props.plugin && this.props.plugin.host) {
      this.setState({
        host: this.props.plugin.host,
        hostFlag: this.props.plugin.hostFlag
      });
    }
  }

  openAuthWindow = host => {
    const width = 700,
      height = 800;
    const x = screen.width / 2 - width / 2;
    const y = screen.height / 2 - height / 2;
       
    window.open(
      `/api/integrations/login${this.props.location.search}${host ? `&h=${host}` : ''}`,
      'targetWindow',
      `toolbar=no,location=no,status=no,menubar=no,width=${width},height=${height},left=${x},top=${y}`
    );

    window.addEventListener('message', this.receiver);
  };

  receiver = event => {
    if (
      !!event.data &&
      (event.data.key === 'auth-token') &&
      !this.received &&
      (process.env.RUN_ENV === 'development' ||
        event.origin.indexOf('//nave.be') > -1 ||
        event.origin.indexOf('naveapp.com') > -1 ||
        event.origin.indexOf('getnave.com') > -1)
    ) {
      this.received = true;
      let token = event.data.value;     
      window.location.replace(`/${window.location.search}`);
      notifyForToken(token);            
    }
  };

  jiraCloudLogin = () => {
    if (this.props.outside) {
      this.openAuthWindow();
    } else {
      window.location.replace(
        `/api/integrations/login${this.props.location.search}`
      );
    }    
  };

  checkUrlAndLogin = () => {
    const host = extractHostname(this.state.host);
    BECaller.api(`integrations/check?host=${host}`, 'get', null, false)
      .then(() => {
        storageHelper.storage().setItem('host', host);
        storageHelper.storage().setItem('hostFlag', this.state.hostFlag);
        if (this.props.outside) {
          this.openAuthWindow(host);
        } else {
          window.location.replace(
            `/api/integrations/login${!!this.props.location.search ? this.props.location.search + '&' : '?'}h=${host}`
          );
        }
      })
      .catch(err => {
        if (err.status === 400) {
          if (this.props.app === 'jira') {
            this.props.handleError(
              <div>
                Please{' '}
                <a
                  className='link'
                  href={`//getnave.com/blog/linking-nave-jira${this.props.location.search}`}
                  target="_blank"
                  onClick={this.trackLinkNaveWithJiraOpen}
                  onAuxClick={this.trackLinkNaveWithJiraOpen}
                >
                  link Nave with Jira
                </a>{' '}
                in order to continue
              </div>
            );
          } else if (this.props.app === 'azure') {
            this.props.handleError(
              <div>
                {intl.formatMessage({
                  id: `${this.props.app}.errors.${err.reason}`
                })}
              </div>
            );
          }
        } else {
          console.error(err);
        }
      });
  };

  trackLinkNaveWithJiraOpen() {
    trackHowToOpened('link_jira');
  }

  handleHostShowChecked = () => {
    this.setState({ hostFlag: !this.state.hostFlag });
  };

  renderJiraView() {
    const { hostFlag } = this.state;
    return (
      <div>
        {hostFlag ? (
          <div>
            <p className='link_account' style={{ marginTop: '0', marginBottom: '16px', textAlign: 'left' }}>
              <a onClick={this.handleHostShowChecked} onAuxClick={this.handleHostShowChecked}>
                {'<  '}Back to Login with Jira Cloud
              </a>
            </p>
            <div className='form_container_no_margin'>
              <label>Host URL</label>
              <input
                className='form-control'
                onChange={e => {
                  this.setState({ host: e.target.value });
                }}
                value={this.state.host}
                type="url"
                placeholder="https://company.atlassian.net"
              />
            </div>
            <Button className='mt-4' variant="primary"
              disabled={!this.state.host}
              onClick={this.checkUrlAndLogin}
              id="checkHostBtn"
            >
              <img src={jira} alt="#" /> Log in with Jira
            </Button>
            <p className='link_account'>
              Don't have an account?{' '}
              <a
                href={`//getnave.com/blog/linking-nave-jira${this.props.location.search}`}
                target="_blank"
                id="howto"
                onClick={this.trackLinkNaveWithJiraOpen}
                onAuxClick={this.trackLinkNaveWithJiraOpen}
              >
                Link Nave with Jira
              </a>
            </p>
          </div>
        ) : (
          <div>
            <Button variant="primary"
              onClick={this.jiraCloudLogin}              
              id="loginBtn"
            >
              <img src={jiraCloud} alt="#" /> Log in with {_.upperFirst(this.props.app)} Cloud
            </Button>
            <p className='link_account'>
              Using Jira Server or Jira Data Center?{' '}
              <a id="howto" onClick={this.handleHostShowChecked} onAuxClick={this.handleHostShowChecked}>
                Log in with host URL
              </a>
            </p>
          </div>
        )}
      </div>
    );
  }

  renderDevOpsView() {
    return (
      <div>
        <div className='form_container'>
          <label>Host URL</label>
          <input
            className='form-control'
            onChange={e => {
              this.setState({ host: e.target.value });
            }}
            value={this.state.host}
            type="url"
            placeholder="https://dev.azure.com/company"
          />
        </div>
        <Button
          variant="primary"
          disabled={!this.state.host}
          onClick={this.checkUrlAndLogin}
          id="loginWindowBtn"
        >
          <img src={asana} alt="#" /> Log in with Azure DevOps
        </Button>
      </div>
    );
  }

  renderLoginView() {
    return <LoginForm params={this.props.location.search} />;
  }

  renderDefaultView() {
    return (
      <React.Fragment>
        {this.props.outside ? (
          <Button variant="primary" onClick={this.openAuthWindow} id="loginWindowBtn">
            <img src={trello} alt="#" /> Log in with {_.upperFirst(this.props.app)}
          </Button>
        ) : (
          <a
            className='btn btn-primary'
            href={`/api/integrations/login${this.props.location.search}`}
            id="loginBtn"
          >
            <img src={trello} alt="#" /> Log in with {_.upperFirst(this.props.app)}
          </a>
        )}
      </React.Fragment>
    );
  }

  render() {
    const isSso = !!this.props.routeParams.accountId;

    if (isSso) {
      return (
        <div className='login_bg'>
          <Helmet
            title="Log in"
            link={[
              {
                rel: 'alternate',
                href: `https://${this.props.app}.getnave.com`,
                hreflang: 'en-us'
              }
            ]}
          />
          <div className='table-loading'><Loading /></div>
        </div>
      );
    }

    return (
      <div className='login_bg'>
        <Helmet
          title="Log in"
          link={[
            {
              rel: 'alternate',
              href: `https://${this.props.app}.getnave.com`,
              hreflang: 'en-us'
            }
          ]}
        />
        <div className={`login_form ${this.props.app}`}>
          <div className='logo'>
            <img src={logo} alt="" />
          </div>
          <div className='login_content'>
            <div className='left_part'>
              <h1>
                <span>Let's reveal your next </span>
                <br/>
                <span>opportunity for improvement!</span>
              </h1>
              {this.props.app === 'jira'
                ? this.renderJiraView()
                : this.props.app === 'azure'
                ? this.renderDevOpsView()
                : this.props.app === 'file'
                ? this.renderLoginView()
                : this.renderDefaultView()}
            </div>
            <div className='right_part'>
              <Testimonial />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LoginPage.propTypes = {
  intl: intlShape.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    handleError: err => dispatch(handleError(err))
  };
};

function mapStateToProps(state) {
  return {
    app: state.app.app,
    outside: state.app.outside,
    plugin: state.app.plugin,
    errorMessage: state.auth.error,
    message: state.auth.message,
    authenticated: state.auth.authenticated
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(LoginPage)));
